import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { initialState } from "./initialState";
import { InfluenceField, VisualIntegration, AdminCatalogState } from "../types/index"
import { RootState } from "types";


export const sliceKey = "AdminCatalogState";


export const AdminCatalogSlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {
    setMainInfluenceField: (
      state: AdminCatalogState,
      action: PayloadAction<{ id: number; influenceField: InfluenceField }>
    ) => {
      state.catalogData[ action.payload.id -1 ].mainInfluenceField =
        action.payload.influenceField;
    },
    setVisualIntegration: (
      state: AdminCatalogState,
      action: PayloadAction<{ id: number; visualIntegration: VisualIntegration }>
    ) => {
      state.catalogData[ action.payload.id -1 ].visualIntegration =
        action.payload.visualIntegration;
    },
  },
})

export const { reducer, actions } = AdminCatalogSlice